import { MultiSelectFilter } from "@/lib/Components/DataTable/Filters/MultiSelectFilter";
import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { contactListQuery } from "@/app/Contacts/GraphQL/contactListQuery";

export function BillingEntityFilter({
  selected,
  onChange,
}: {
  selected: string[];
  onChange: (ids: string[]) => void;
}) {
  const { data } = useGqlQuery(contactListQuery, {
    page: 1,
    first: 200,
  });

  const options =
    data?.contacts.data.map((c) => ({
      label: c.name as string,
      value: c.id,
    })) ?? [];

  return (
    <MultiSelectFilter
      label="Entity"
      options={options}
      selected={selected}
      onChange={onChange}
    />
  );
}
